import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import { addSpace, lorem, rescueHtml } from '../components/Tools.js';


const Page4Pilotage = (props) =>
{
    const blue = '#069BD3';
    const greyChapter = '#DBDBDB';
    const height = (props.height*50/950);
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;


    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header */}
            <div style={{display: 'flex', height: '20%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: props.height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>{props.nom}</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.index !== null ? '('+props.index+'/'+props.indexTotal+')' : ''}</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des projets</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '60%', fontSize: fontsize}}>
                
                {/* Header */}
                <div style={{flex: 1, display: 'flex', marginRight: 10, marginLeft: 10, justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>
                    <div style={{flex: 0.1, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>N°</p>
                    </div>
                    <div style={{width: (props.width/25), justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>État</p>
                    </div>
                    <div style={{flex: 1, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Intitulé</p>
                    </div>
                    <div style={{flex: 0.4, justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                        <p>Date de la</p>
                        <p>dernière décision</p>
                    </div>
                    <div style={{flex: 0.9, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Décision</p>
                    </div>
                    <div style={{flex: 0.4, justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                        <p>Date limite</p>
                        <p>de l'action</p>
                    </div>
                    <div style={{flex: 0.9, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Action suivante</p>
                    </div>
                </div>

                {props.projets.map((projet, i) => (
                    <div
                        key={i}
                        style={{flex: 1, display: 'flex', margin: (fontsize-2), border: '1px solid '+greyChapter, borderRadius: 5}}
                    >
                        {/* Numéro du projet */}
                        <div style={{flex: 0.1, display: 'flex', justifyContent: 'center'}}>
                            <p style={{display: 'flex', alignItems: 'center', height: height, overflow: 'hidden'}}>{projet[2]?projet[2]:''}</p>
                        </div>

                        {/* État / couleur */}
                        <div style={{width: (props.width/25), display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <div style={{border: '1px solid '+projet[27], backgroundColor: projet[27], borderRadius: '100%', width: "80%", height: "80%"}}></div>
                        </div>

                        {/* Intitulé */}
                        <div style={{flex: 1, display: 'flex'}}>
                            <p style={{display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden', fontWeight: 'bold'}}>{projet[3]?rescueHtml(projet[3]):''}</p>
                        </div>

                        {/* Date de la dernière décision */}
                        <div style={{flex: 0.4, display: 'flex', justifyContent: 'center'}}>
                            <p style={{display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden'}}>{projet['pilotage_date'] && projet['pilotage_date'] !== '0000-00-00'? (projet['pilotage_date'].split('-')[2]+'/'+projet['pilotage_date'].split('-')[1]+'/'+projet['pilotage_date'].split('-')[0]) : ''}</p>
                        </div>

                        {/* Décision */}
                        <div style={{flex: 0.9, display: 'flex', fontSize: (fontsize-3)}}>
                            <p style={{display: 'flex', padding: 5, height: height, overflow: 'hidden'}}>{projet['pilotage_decision']?rescueHtml(projet['pilotage_decision']):''}</p>
                        </div>

                        {/* Date limite de l'action */}
                        <div style={{flex: 0.4, display: 'flex'}}>
                            <p style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: height, overflow: 'hidden'}}>{projet['pilotage_date_limite'] && projet['pilotage_date_limite'] !== '0000-00-00'?(projet['pilotage_date_limite'].split('-')[2]+'/'+projet['pilotage_date_limite'].split('-')[1]+'/'+projet['pilotage_date_limite'].split('-')[0]):''}</p>
                        </div>

                        {/* Action suivante */}
                        <div style={{flex: 0.9, display: 'flex', fontSize: (fontsize-3)}}>
                            <p style={{flex: 1, display: 'flex', padding: 5, height: height, overflow: 'hidden'}}>{projet['pilotage_action_suivante']?rescueHtml(projet['pilotage_action_suivante']):''}</p>
                        </div>

                    </div>
                ))}
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '20%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page4Pilotage;